import { AbstractParser } from "../../parser";
import { IndicatorData } from "src/app/ui/models/domains/pbm/indicators/indicator-data";
import { parseIdicatorData } from "./indicator-parse-functions";

export class IndicatorDataParser extends AbstractParser<IndicatorData[]> {
  parse(payload: any): IndicatorData[] {
    return parseIdicatorData(payload);
  }
}
